"use strict";

import $ from "jquery";
import "owl.carousel";
import { dataAttrOptions } from "./slider.helper";

export default function slideSecondaryNews(scope) {
    const defaults = {
        items: 1,
        margin: 30,
        loop: true,
        nav: true,
        navText: ["&nbsp;", "&nbsp;"],
        dots: false,
    };

    $(scope).each(function () {
        const elm = $(this);
        const settings = dataAttrOptions(defaults, elm.data());

        function initSlider(mql) {
            if (mql.matches) {
                elm.owlCarousel(settings);
            } else {
                elm.trigger("destroy.owl.carousel");
            }
        }

        const mql = window.matchMedia("(max-width: 767px)");
        mql.addListener(initSlider);
        initSlider(mql);
    });
}
